import { Injectable } from '@angular/core';
import * as CodeCompletionEditor from './code-completion.types';

@Injectable()
export abstract class CellEditorStateFacade {
  abstract registerCellEditor(editor: any, cellToken: string): void;
  abstract setCurrentCellToken(cellToken: string): void;
  abstract getCellEditorContext(): CodeCompletionEditor.EditorContext;
  abstract isCellSelected(cellToken: string): boolean;
}
